import { render, staticRenderFns } from "./TikTokFollow.vue?vue&type=template&id=31b4631c&"
import script from "./TikTokFollow.vue?vue&type=script&lang=ts&"
export * from "./TikTokFollow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports